import { FullScreenError } from '@moniebook-web/components/molecules/full-screen-error';
import { PAGES } from '@register-ui/utils';

function ErrorMessage() {
    return (
        <div className='flex flex-col gap-24 pt-20'>
            <p className='text-14 text-neutral-s10'>
                Looks like we hit a snag. Don't worry, our team has been
                notified, and we're on it.
            </p>
            <p className='text-14 text-neutral-s10'>
                Refresh the page to try again. Click the button below to head
                back to the homepage.
            </p>
        </div>
    );
}

interface ServiceUnavailableProps {
    actionLink?: string;
}

export function ServiceUnavailable(props: Readonly<ServiceUnavailableProps>) {
    const { actionLink = PAGES.HOME } = props;

    return (
        <FullScreenError
            showLogo
            title='Oops, something went wrong!'
            message={<ErrorMessage />}
            actionText='Go to Homepage'
            actionLink={actionLink}
            hardReload
        />
    );
}
